import styled from 'styled-components';

/**
 * This is to fix some overwritten styles related to an inner pre tag
 */
const PreTagContainer = styled.div`
  pre {
    margin-bottom: 0;
  }
`;

export default PreTagContainer;
